var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 27.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 27.5,
    stroke: "#ECE9E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4916 29.9918L28.825 34.6585C28.3693 35.1141 27.6306 35.1141 27.175 34.6585L22.5084 29.9918C22.0528 29.5362 22.0528 28.7975 22.5084 28.3419C22.964 27.8863 23.7027 27.8863 24.1583 28.3419L26.8333 31.0169V17.5002C26.8333 16.8558 27.3557 16.3335 28 16.3335C28.6443 16.3335 29.1667 16.8558 29.1667 17.5002V31.0169L31.8417 28.3419C32.2973 27.8863 33.036 27.8863 33.4916 28.3419C33.9472 28.7975 33.9472 29.5362 33.4916 29.9918Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 34.4168C18.6667 33.7725 18.1443 33.2502 17.5 33.2502C16.8557 33.2502 16.3333 33.7725 16.3333 34.4168V36.1668C16.3333 38.7442 18.4227 40.8335 21 40.8335H35C37.5773 40.8335 39.6667 38.7442 39.6667 36.1668V34.4168C39.6667 33.7725 39.1443 33.2502 38.5 33.2502C37.8557 33.2502 37.3333 33.7725 37.3333 34.4168V36.1668C37.3333 37.4555 36.2887 38.5002 35 38.5002H21C19.7113 38.5002 18.6667 37.4555 18.6667 36.1668V34.4168Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowIcon3);
export default __webpack_public_path__ + "static/media/flowIcon3.1549e859a2816f56253d0a7e8e3c9cd9.svg";
export { ForwardRef as ReactComponent };